const useGetInfoBrowser = () => {
  const ua = navigator.userAgent

  const isOpera = ua.includes('OPR')
  const isFirefox = ua.includes('Firefox') || ua.includes('FxiOS')
  const isEdge = ua.includes('Edg')
  const isChrome = (ua.includes('Chrome') || ua.includes('CriOS')) && !isEdge && !isOpera

  // Safari aparece en TODOS los navegadores de iOS,
  // así que necesitamos excluir Chrome (CriOS) y Firefox (FxiOS)
  const isSafari =
    ua.includes('Safari') &&
    !ua.includes('Chrome') &&
    !ua.includes('CriOS') &&
    !ua.includes('FxiOS') &&
    !ua.includes('Edg')

  // Safari en iPhone/iPad
  const isIPad = /iPad|Macintosh/.test(ua) && 'ontouchend' in document
  const isIPhone = /iPhone/.test(ua)
  const isSafariMobile = isSafari && (isIPhone || isIPad)

  if (isOpera) return { isCompatible: false, nameBrowser: 'Opera' }
  if (isFirefox) return { isCompatible: false, nameBrowser: 'Firefox' }
  if (isEdge) return { isCompatible: true, nameBrowser: 'Edge' }
  if (isChrome) return { isCompatible: true, nameBrowser: 'Chrome' }

  // Safari iPhone/iPad (compatible si quieres)
  if (isSafariMobile) return { isCompatible: true, nameBrowser: 'Safari (iOS)' }

  // Safari desktop (si no quieres soportarlo)
  if (isSafari) return { isCompatible: false, nameBrowser: 'Safari' }

  return { isCompatible: false, nameBrowser: 'Desconocido' }
}

export default useGetInfoBrowser
